import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import store from "stores/configStore";
import { ThemeProvider } from "styled-components";

import "./index.css";

import App from "./App";
import i18n from "./locale";
import reportWebVitals from "./reportWebVitals";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!./assets/styles/index.scss');

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <ReduxProvider store={store}>
      <div className="App">
        <I18nextProvider i18n={i18n}>
          <ToastContainer
            autoClose={10000}
            theme="colored"
            hideProgressBar
            pauseOnHover={false}
          />
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </I18nextProvider>
      </div>
    </ReduxProvider>
  </GoogleOAuthProvider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// registerServiceWorker();
